import { getRoleName } from "web/src/utils"
import { DEFAULT_ROLES, SYSTEM_COMPONENTS_IDS } from "../root/constants"

export function getCustomerOptions(p, customers) {
    if (!customers) {
        return Object.keys(p).filter(customerId => {
            return p[customerId].hasOwnProperty(SYSTEM_COMPONENTS_IDS.user_management)
                && p[customerId][SYSTEM_COMPONENTS_IDS.user_management].indexOf('c') >= 0
        }).reduce((acc, customerId) => {
            acc[customerId] = p[customerId].customer_name
            return acc
        }, {})
    }
    return customers.reduce((acc, c) => {
        acc[c.id] = c.name
        return acc
    }, {})
}

export function getRoleTableData(role, user) {
    if (!role) return null
    const componentsCopy = { ...role.components }

    // for security reasons we temporarily hiding user management
    delete componentsCopy[SYSTEM_COMPONENTS_IDS.user_management]
    delete componentsCopy[SYSTEM_COMPONENTS_IDS.customers]

    const a = Object.keys(componentsCopy).map(componentKey => {
        return {
            component: componentKey,
            ...componentsCopy[componentKey]
        }
    })
    return a
}

export const selectAlRoles = state => state.userManagement.roles
    ? state.userManagement.roles.reduce((acc, role) => {
        if (!acc.hasOwnProperty(role.customer_id)) {
            acc[role.customer_id] = {}
        }
        acc[role.customer_id][role.id] = getRoleName(role, state.main.locale)
        return acc
    }, {})
    : null